export const PA_CREATE_DATAOVERRIDE = 'paCreateDataOverride';
export const PA_CREATE_DATAOVERRIDE_CLEAR_MESSAGE = 'clearMessage';
export const PA_SEARCH_DATAOVERRIDE = 'paSearchDataOverride';



// WEBPACK FOOTER //
// ./src/store/dataoverride/actions.type.js